import React from "react";
import TabDistributorApplication from "./TabDistributorApplication";

type Props = {};

const TabDistributorApplicationWrapper = (props: Props) => {
  return (
      <TabDistributorApplication />
  );
};

export default TabDistributorApplicationWrapper
